<table mat-table [dataSource]="dataSource">
    @for (column of columns; track column; let i = $index) {
        <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="getHeadingWidth(column)" [style]="getHeaderStyle(column)"> {{headings[column]}} </th>
            <td mat-cell *matCellDef="let element" [style]="getNumberStyle(element, column)">
                @if (column === 'icon') {
                    @if (isCost()) {
                        <app-node-svg [type]="element.type" [noText]="true" [height]="26"/>
                    }@else {
                        <span class="material-symbols-outlined">
                            {{getCarbonIcon(element)}}
                        </span>
                    }
                }@else if (column === 'superType') {
                    {{getSuperType(element[column])}}
                }@else if (column === 'scope') {
                    {{element[column]||''}}
                }@else if (column === 'colour') {
                    <span class="box" [style]="'background-color: ' + getColour(element.scope, element.superType)"></span>
                }@else if (!isCost() || column === 'hours' || column === 'hours2') {
                    {{element[column] | number}}
                }@else {
                    {{element[column] | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
                }
            </td>
            @if (column === 'superType' || column === 'scope') {
                <td mat-footer-cell *matFooterCellDef> Total </td>
            }@else if (column === 'hours' || column === 'hours2') { 
                <td mat-footer-cell *matFooterCellDef [style]="getHeaderStyle(column)"> {{totals[column] | number}} </td>
            }@else {
                <td mat-footer-cell *matFooterCellDef [style]="getHeaderStyle(column)"> {{totals[column] | currency: currencyCode: 'symbol-narrow': '1.0-0'}} </td>
            }
        </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="getHeadings(); sticky:true"></tr>
    <tr mat-row *matRowDef="let element; columns: columns;" (click)="selectRow(element.scope); $event.stopPropagation()" [ngClass]="{'selected-row': element === selectedRow}"></tr>
    <tr mat-footer-row *matFooterRowDef="columns"></tr>
</table>
@if (!tableOnly) {
    <app-bar-chart [data]="barData" [comparison]="comparisonName" [isStacked]="true" [stacks]="stacks" [height]="300" [width]="500" [hideLegend]="true"></app-bar-chart>
}